"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const colors_1 = require("../../assets/jss/colors");
const package_1 = require("../../package");
const styles = (theme) => {
    const isAltStyleEnabled = package_1.config.internalConfig.ENABLE_ALT_TICKET_CARD_STYLE;
    return (0, styles_1.createStyles)({
        pagination: {
            display: 'flex',
            paddingLeft: '0',
            listStyle: 'none',
            borderRadius: '0.25rem',
            justifyContent: 'center',
            alignItems: 'center'
        },
        paginationItem: {
            display: 'inline'
        },
        paginationLink: Object.assign(Object.assign({ ':first-of-type': {
                marginleft: '0'
            }, border: '0', borderRadius: '25px !important', transition: 'all .3s', padding: '0px 5px', margin: '0 3px', minWidth: '25px', height: '25px', minHeight: 'auto', lineHeight: '25px', fontWeight: 400, fontSize: '12px', textTransform: 'uppercase', background: 'transparent', position: 'relative', float: 'left', textDecoration: 'none', boxSizing: 'border-box', '&,&:hover,&:focus': {
                color: theme.palette.grey['900']
            }, '&:hover,&:focus': {
                zIndex: 3,
                backgroundColor: theme.palette.grey['400'],
                borderColor: theme.palette.grey['600']
            } }, (isAltStyleEnabled
            ? {
                '&:focus, &:focus-visible': {
                    backgroundColor: 'transparent',
                    color: 'inherit'
                }
            }
            : {})), { '&:hover': {
                cursor: 'pointer'
            }, '&:disabled': {
                color: theme.palette.grey['600']
            }, '&.Mui-focusVisible': {
                boxShadow: `0 0 0px 2px white, 0 0 0 6px ${colors_1.default.themeColors.boxShadowColor.hex()}`
            } }),
        primary: {
            '&,&:hover,&:focus': {
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText
            },
            '&:hover,&:focus': {
                zIndex: 2,
                cursor: 'default'
            },
            '&:focus': {
                boxShadow: `0 0 0px 2px white, 0 0 0 6px ${colors_1.default.themeColors.boxShadowColor.hex()}`
            }
        },
        textPrimary: {
            '&,&:hover,&:focus': {
                backgroundColor: theme.palette.text.primary,
                borderColor: theme.palette.text.primary,
                color: theme.palette.common.white,
                boxShadow: theme.shadows[4]
            },
            '&:hover,&:focus': {
                zIndex: 2,
                cursor: 'default'
            }
        },
        secondary: {
            '&,&:hover,&:focus': {
                backgroundColor: theme.palette.secondary.main,
                borderColor: theme.palette.secondary.main,
                color: theme.palette.secondary.contrastText,
                boxShadow: theme.shadows[4]
            },
            '&:hover,&:focus': {
                zIndex: 2,
                cursor: 'default'
            }
        }
    });
};
exports.default = styles;
//# sourceMappingURL=PaginationStyle.js.map